export enum SuggestionQuickActionType {
    FindProspects = "findProspects",
    CreateList = "createList",
    EnrichCompanies = "enrichCompanies",
    PrepareForMeeting = "prepareForMeeting",
    CraftEmail = "craftEmail",
    ScoringCriteria = "scoringCriteria",
}
